import type {
  ColDef,
  GridApi,
  IServerSideGetRowsParams,
} from 'ag-grid-enterprise';
import { INVENTORY_PAGE_SIZE } from '../inventoryConsts';
import type { ReferenceInventoryColDef } from './referenceInventoryColumns';
import type {
  NextReferenceRowsBatchParams,
  ReferenceInventoryRow,
  RequestedReferenceColumn,
} from './types';

const isReferenceInventoryColDef = (
  colDef: ColDef<ReferenceInventoryRow>
): colDef is ReferenceInventoryColDef =>
  typeof colDef.context?.key === 'string';

const getDisplayedReferenceColumns = (
  gridApi: GridApi<ReferenceInventoryRow>
): RequestedReferenceColumn[] =>
  gridApi
    .getAllDisplayedColumns()
    .map(column => column.getColDef())
    .filter(isReferenceInventoryColDef)
    .map(({ context }) => context);

export const mapAgGridParamsToReferenceBatchParams = ({
  request: { startRow, endRow },
  api,
}: IServerSideGetRowsParams<ReferenceInventoryRow>): NextReferenceRowsBatchParams => ({
  from: startRow ?? 0,
  size: (endRow ?? INVENTORY_PAGE_SIZE) - (startRow ?? 0),
  columns: getDisplayedReferenceColumns(api),
});
